import { useRoutes, Navigate } from "react-router-dom";

// layouts
import FullScreenLayout from "../layouts/baseLayout";
import AuthGuard from "../layouts/Authguard";
import AdminAuthGuard from "../layouts/adminAuthguard";
import SearchLayout from "../layouts/searchLayout";

// pages

import HomePage from "pages/Home";
import AboutUs from "pages/AboutUs";
import BusRoutes from "pages/BusRoutes";
import BusRoutesSearchPage from "pages/BusRoutes/SearchPage";
import BusroutesTableDPSDubai from "pages/BusRoutes/BusroutesTableDPSDubai";
import BusRoutesWithTime from "pages/BusRoutes/BusRoutesWithTime";
import Services from "pages/Services";
import DPSDUBAIFEES from "pages/Fees/dpsDubai";
import DPSRAKFEES from "pages/Fees/dpsRAK";
import FeesPage from "pages/Fees";
import ParentAgreement from "pages/ParentAgreement";
import PaymentModes from "pages/PaymentModes";
import ContactUs from "pages/ContactUs";
import Page404 from "pages/404";
import FeesFAQs from "pages/FAQ/FeesFAQ";
import LogisticsFAQ from "pages/FAQ/LogisticsFAQ";
import Careers from "pages/Careers/careers";
import Maintance from "pages/Maintenance/Index";
import TransportForm from "Sections/TransportForm";
import Admin from "Sections/Admin";
import Login from "Sections/Login";
import VerifyPage from "Sections/Login/VerifyPage";
import Dashboard from "Sections/Dashboard";
import ParentDashboard from "Sections/Parents";
// import Maintance from "pages/Maintenance";

export default function Routes() {
  return useRoutes([
    {
      path: "/services",
      element: <FullScreenLayout />,
      children: [
        { path: "bus-routes-update", element: <BusRoutes /> },
        { path: "bus-routes", element: <BusroutesTableDPSDubai /> },
        { path: "service-summary", element: <Services /> },
      ],
    },
    {
      path: "bus-routes",
      element: <FullScreenLayout />,
      children: [{ path: "driver-details-dps-dubai", element: <BusRoutesWithTime /> }],
    },

    {
      path: "/services/bus-routes/search",
      element: <FullScreenLayout />,
      children: [{ path: "", element: <BusRoutesSearchPage /> }],
    },
    {
      path: "/fees",
      element: <FullScreenLayout />,
      children: [
        { path: "details", element: <FeesPage /> },
        { path: "payment-modes", element: <PaymentModes /> },
        { path: "details", element: <DPSDUBAIFEES /> },
        { path: "dps-rak", element: <DPSRAKFEES /> },
        { path: "parents-agreement", element: <ParentAgreement /> },
      ],
    },
    {
      path: "/faq",
      element: <FullScreenLayout />,
      children: [
        { path: "fees", element: <FeesFAQs /> },
        { path: "logistics", element: <LogisticsFAQ /> },
      ],
    },
    {
      path: "/careers",
      element: <FullScreenLayout />,
      children: [{ path: "list", element: <Careers /> }],
    },
    {
      path: "/services",
      element: <FullScreenLayout />,
      children: [
        { path: "transport", element: <Services /> },
        { path: "maintenance", element: <Maintance /> },
      ],
    },
    {
      path: "/forms",
      element: <FullScreenLayout />,
      children: [{ path: "transport-form", element: <TransportForm /> }],
    },
    {
      path: "/admin",
      element: <AdminAuthGuard role={1} />,
      children: [{ path: "portal", element: <Dashboard /> }],
    },
    {
      path: "/parents",
      element: <AuthGuard role={3} />,
      children: [{ path: "portal", element: <ParentDashboard /> }],
    },
    {
      path: "/admin",
      children: [
        { path: "login", element: <Login /> },
        { path: "verify/:token", element: <VerifyPage /> },
      ],
    },
    {
      path: "/",
      element: <FullScreenLayout />,
      children: [
        { path: "/", element: <HomePage /> },
        { path: "/about-us", element: <AboutUs /> },
        { path: "/services", element: <AboutUs /> },
        { path: "/contact-us", element: <ContactUs /> },
        { path: "*", element: <Page404 /> },
      ],
    },
  ]);
}
